<template>
  <!-- 兑换码管理 -->
  <div class="app-control-right-cr" v-loading="loaded">
    <!-- 标题 -->
    <ActivationCodeTitle ref="ActivationCodeTitle"></ActivationCodeTitle>
    <!-- 主内容 -->
    <ActivationCodeTable v-if="activationTableData !== undefined" :activation-table-data="activationTableData"
                         v-loading="tableLoad"></ActivationCodeTable>
  </div>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import util from "@/components/util";
import ActivationCodeTitle from "@/views/control/components/property/ActivationCode/ActivationCodeTitle";
import ActivationCodeTable from "@/views/control/components/property/ActivationCode/ActivationCodeTable";

export default {
  name: "ActivationCodeControl",
  components: {
    ActivationCodeTable,
    ActivationCodeTitle,
  },
  data() {
    return {
      activationTableData: undefined,
      loaded: true,
      tableLoad: false,
    }
  },
  mounted() {
    this.getActivationCodeData()
  },
  methods: {
    getActivationCodeData() {
      this.tableLoad = true;
      this.activationTableData = undefined;
      AxiosBase.axiosGet("/property-ad/get-activation-code", {
        params: {
          key: this.$refs.ActivationCodeTitle.searchKey
        }
      }).then(response => {
        if (response !== 0) {
          response.data.forEach(jsonObject => {
            jsonObject.trackTime = util.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(jsonObject.trackTime))
          });
          this.activationTableData = response.data;
          this.tableLoad = false;
          this.loaded = false;
        }
      })
    },
  }
}
</script>

